export default __webpack_public_path__ + "static/media/BA.32c14c8f.gif";